<template lang="html">
  <section class="ctn-articles take-place column start">
		<div class="ctn-actualities column">
			<div class="ctn-filters row">
				<div class="filter" v-for="(tag, key) in tags" :class="{active: isTagActive(key)}" @click="activeTag(key)" v-bind:key="key">
					{{ tag.name }}
				</div>
			</div>
			<div class="ctn-columns row">
				<div class="ctn-advises">
					<advise v-for="(advise, key) in filter(news)" v-bind:key="key" :article="advise"/>
				</div>
			</div>
		</div>
  </section>
</template>

<script>
import Advise from '@/common/components/advise'
import { mapGetters } from 'vuex'
export default {
	name: 'Banque',
	components: {
		Advise
	},
	data () {
		return {
			activeTags: []
		}
	},
	methods: {
		isTagActive (key) {
			return (this.activeTags.indexOf(key) !== -1)
		},
		activeTag (key) {
			if (this.activeTags.indexOf(key) === -1) {
				this.activeTags.push(key)
			} else {
				this.activeTags.splice(this.activeTags.indexOf(key), 1)
			}
		},
		filter (news) {
			if (this.activeTags.length === 0) {
				return news
			} else {
				let result = []
				news.forEach((n) => {
					let shouldBeAdd = (n.news_tags.length > 0)
					n.news_tags.forEach((t) => {
						let isTag = false
						this.activeTags.forEach((tag) => {
							if (typeof t === 'number') {
								if (t === this.tags[tag].wordpress_tag_id) isTag = true
							} else {
								if (t.wordpress_tag_id === this.tags[tag].wordpress_tag_id) isTag = true
							}
						})

						if (!isTag) shouldBeAdd = false
					})
					if (shouldBeAdd) result.push(n)
				})

				return result
			}
		}
	},
	computed: {
		...mapGetters({
			news: 'banqueNews',
			tags: 'tags'
		})
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/views/Actualities/Banque.vue